module.exports = __webpack_public_path__ + "static/lux_cloud-d4346a263fa4dfd619d32188a5ca1864.jpg";